import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ProviderWithIntegrationDetailFragment = { id: string, name: string, url: string, logo: { url?: string | null }, integrationProvider?: { id: string, provider: Types.IntegrationProviderEnum, integrationDetail?: { id: string, status: Types.IntegrationStatusEnum } | null } | null };


export type ProviderWithIntegrationDetailFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ProviderWithIntegrationDetailFragmentDoc = /*#__PURE__*/ gql`
    fragment ProviderWithIntegrationDetail on ProviderType {
  id
  name
  logo {
    url
  }
  url
  integrationProvider {
    integrationDetail {
      id
      status
    }
    id
    provider
  }
}
    `;